import { defineMessages } from 'react-intl';

export const exportMessageDefinitions = defineMessages({
  pdfPageNOfM: {
    id: 'export.pdf.pageNOfM',
    defaultMessage: 'Page {currentPageNumber} of {totalPagesCount}',
  },
  pdfPoweredBy: {
    id: 'export.pdf.poweredBy',
    defaultMessage: 'Powered by Estimation.World',
  },
});
